define(function (require) {
	"use strict";

	/*-----------------------------------------------------------------------------------------------*/
	var LE = require("app");
	//Template
	var template = require("user-management-templates/lobs/lobsFooter.tmpl");
	var CONST = require("const");


	var LobsFooterView = {};

	function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

		LobsFooterView = Marionette.ItemView.extend({

			isPermanent: true,
			className: "lobs-footer",
			template: template,
			ui:{
				backToListBtn: ".back-to-list-container",
				createNewBtn: ".create-new-button"
			},
			events:{
				"click @ui.backToListBtn": "_backToList",
				"click @ui.createNewBtn": "_createNew"
			},

			//Marionette-Functions"
			/*-----------------------------------------------------------------------------------------------*/
			initialize: function () {
				LEUserManagement.logger.debug("Initializing LobsFooterView", "LobsFooterView:initialize");
			},

			onRender: function() {
				this.isNavigationEnabled = true;
				this.listenTo(LEUserManagement.vent, "lobs:enableNavigation", this._enableNavigation);
			},

			onClose: function () {
				LEUserManagement.logger.debug("closing LobsFooterView", "LobsFooterView:onClose");
			},

			//privateFunctions
			/*-----------------------------------------------------------------------------------------------*/
			_backToList: function () {
				if (this.isNavigationEnabled) {
					LEUserManagement.logger.debug("Lobs footer: user clicked back to list button.", "LobsFooterView:_backToList");
					LEUserManagement.router.navigate("lobs");
				}
			},

			_createNew: function() {
				if (this.isNavigationEnabled) {
					LEUserManagement.logger.debug("Lobs footer: user clicked new lob button.", "LobsFooterView:_createNew");
					LEUserManagement.router.navigate("lobs/" + CONST.ROUTING.NEW_ITEM_ID);
				}

			},

			_enableNavigation: function(enabled) {
				this.isNavigationEnabled = enabled;
			}
		});
	}

	LE.module("LEUserManagement", moduleDefinition);

	return LobsFooterView;

});
